<template>
  <div id="todayBannerModal" class="content">
    <modal :show.sync="shouldShow" v-on:close="onClose" footerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="modal-title">
        <b>이벤트 배너 설정</b>
      </h4>
      <div>
        <div class="row" @paste="onBannerPaste">
          <label class="col-sm-2 col-form-label">배너추가</label>

          <base-button @click="addBanner" type="success">+</base-button>

          <base-button @click="copyBanners">복사</base-button>
        </div>
        <draggable class="row" handle=".handle" v-model="banners" group="people" @start="drag = true" @end="drag = false">
          <div class="col-sm-12" v-for="(banner, index) in banners">
            <div class="row">
              <div class="col-sm-10">
                <div class="row">
                  <div class="col-sm-6">
                    <BlipFileUploadZone :upload-category="9" :index="index" :maxFiles="1" :fileUrl="banner.imageUrl" @onChangeFileIds="onMediaFileIdChange" />
                  </div>
                  <div class="col-sm-6">
                    <div class="row">
                      <label class="col-sm-4 col-form-label">링크<span style="color: red">*</span></label>
                      <div class="col-sm-8">
                        <LinkSelect @linkChangeEvent="getLink" class="link-selection" :link-model="'banners.' + index + '.link'" />
                        <base-input placeholder="링크" v-model="banner.link">
                          <span slot="helpBlock" class="form-text" />
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-2 col-form-label">타이틀 KEY</label>
                  <div class="col-sm-4">
                    <base-input placeholder="타이틀 KEY" v-model="banner.title">
                      <span slot="helpBlock" class="form-text" />
                    </base-input>
                  </div>
                  <label class="col-sm-2 col-form-label">설명 KEY</label>
                  <div class="col-sm-4">
                    <base-input placeholder="설명 KEY" v-model="banner.description">
                      <span slot="helpBlock" class="form-text" />
                    </base-input>
                  </div>
                </div>
              </div>
              <base-button class="handle" @click="removeBanner(index)" type="default">-</base-button>
            </div>
            <div class="row">&nbsp;</div>
          </div>
        </draggable>
      </div>
      <div slot="footer" class="justify-content-center">
        <base-button class="footer-buttons col-6" type="success" round @click.native="onClickConfirm">확인</base-button>
        <base-button class="footer-buttons col-6" type="danger" round @click.native="onClickCancel">취소</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import { BaseInput, Modal } from "@/components/index";
import BaseButton from "@/components/BaseButton";
import BlipFileUploadZone from "@/components/BlipFileUploadZone";
import draggable from "vuedraggable";
import { Toast } from "@/util/Toast";
import swal from "sweetalert2";
import LinkSelect from "@/pages/Components/LinkSelect.vue";

export default {
  name: "TodayBannerModal",
  components: {
    BaseButton,
    BaseInput,
    Modal,
    BlipFileUploadZone,
    LinkSelect,
    draggable,
  },
  created() {
    this.isProcessing = false;
    this.banners.map((banner) => {
      if (banner.imageFileId) {
        banner.imageUrl = window.Endpoints.imageServerUrl + banner.imageFileId;
      }
      return banner;
    });
  },
  data() {
    return {};
  },
  props: {
    banners: Array,
    sectionIndex: Number,
    cardIndex: Number,
    unitId: Number,
    shouldShow: {
      type: Boolean,
      required: true,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  methods: {
    copyBanners() {
      const dom = document.createElement("textarea");
      document.body.appendChild(dom);
      dom.value = JSON.stringify(this.banners);
      dom.select();
      document.execCommand("copy");
      document.body.removeChild(dom);
      Toast.success("클립보드에 배너가 복사되었습니다");
    },
    addBanner() {
      this.banners.push({ title: null, description: null, imageFileId: null, imageUrl: null, link: null });
    },
    removeBanner(index) {
      if (index !== -1) {
        this.banners.splice(index, 1);
      }
    },
    onMediaFileIdChange(newFileIds, index) {
      this.banners[index].imageFileId = newFileIds[0];
      this.banners[index].imageUrl = window.Endpoints.imageServerUrl + newFileIds[0];
    },
    getLink(param) {
      const linkModel = param.linkModel.split(".");
      if (linkModel.length === 1) {
        this[linkModel[0]] = param.value;
      } else if (linkModel.length === 2) {
        this[linkModel[0]][linkModel[1]] = param.value;
      } else if (linkModel.length === 3) {
        this[linkModel[0]][linkModel[1]][linkModel[2]] = param.value;
      }
    },
    async onClose() {
      await this.onCancel();
    },
    async onClickConfirm() {
      if (this.isProcessing) {
        return;
      }
      let isValid = true;
      this.banners.forEach((banner) => {
        if (!banner.link) {
          isValid = false;
        }
        if (!banner.imageFileId) {
          isValid = false;
        }
      });
      if (!isValid) {
        Toast.error("필수 항목을 입력해주세요");
        return;
      }
      await this.onConfirm(this.banners);
    },
    onBannerPaste(e) {
      // Stop data actually being pasted into div
      e.stopPropagation();
      e.preventDefault();

      const pastedData = e.clipboardData.getData("text");

      try {
        const json = JSON.parse(pastedData);
        if (Array.isArray(json)) {
          for (const banner of json) {
            this.banners.push(banner);
          }
        } else {
          Toast.error("잘못된 데이터입니다");
        }
      } catch (e) {
        Toast.error("잘못된 데이터입니다");
      }
    },

    onClickCancel: async function () {
      if (this.banners.length > 0) {
        swal
          .fire({
            title: "취소",
            text: `정말 취소하시겠습니까?`,
            type: "warning",
            showCancelButton: true,
            customClass: {
              confirmButton: "btn btn-danger btn-fill",
              cancelButton: "btn btn-cancel btn-fill",
            },
            confirmButtonText: "예",
            cancelButtonText: "아니요",
            buttonsStyling: false,
          })
          .then(async (selection) => {
            if (selection.value) {
              await this.onCancel();
            }
          });
      } else {
        await this.onCancel();
      }
    },
  },
};
</script>
<style lang="scss">
#todayBannerModal .modal-dialog {
  max-width: 1000px !important;
  overflow-y: initial !important;
}
#todayBannerModal .modal-content {
  overflow-y: scroll;
  height: 600px;
}
.footer {
  .footer-buttons {
    width: 100px;
  }
}
</style>
